/** Presentation only. Date-only values never pass through the browser's local time zone. */
export const text = value => value == null ? '' : typeof value === 'string' ? value : value.name || value.label || '';
export const today = () => new Date().toISOString().slice(0, 10);
export const eventDate = item => item?.date || item?.eventDate || item?.startDate;
export const initials = name => text(name).split(' ').filter(Boolean).slice(0, 2).map(part => part[0]).join('').toLocaleUpperCase('tr-TR');
const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
function validDateOnly(value) {
  if (value instanceof Date || typeof value === 'number') {
    const date = new Date(value); return Number.isNaN(date.valueOf()) ? null : date;
  }
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00Z`);
  return Number.isNaN(date.valueOf()) || date.toISOString().slice(0, 10) !== value ? null : date;
}
export function formatDateOnly(value, options = {}) {
  const date = validDateOnly(value);
  return date ? new Intl.DateTimeFormat('tr-TR', { ...dateOptions, ...options, timeZone: 'UTC' }).format(date) : 'Tarih netleşiyor';
}
export function formatTimestamp(value, options = {}) {
  if (value == null || value === '') return 'Tarih netleşiyor';
  const date = new Date(value);
  return Number.isNaN(date.valueOf()) ? 'Tarih netleşiyor' : new Intl.DateTimeFormat('tr-TR', { ...dateOptions, ...options }).format(date);
}
export function formatDate(value, options = {}) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? formatDateOnly(value, options) : formatTimestamp(value, options);
}
export const dateText = formatDateOnly;
export const period = campaign => `${formatDateOnly(campaign.startDate)} — ${formatDateOnly(campaign.endDate)}`;
export function rangeText(row) {
  return row.endDate && row.endDate !== row.startDate ? `${formatDateOnly(row.startDate)} – ${formatDateOnly(row.endDate)}` : formatDateOnly(row.startDate);
}
export function formatMoney(value, currency, { estimate = false } = {}) {
  if (value == null || value === '' || !Number.isFinite(Number(value))) return 'Bedel netleşiyor';
  const number = Number(value), prefix = estimate ? '≈ ' : '';
  const plain = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 }).format(number);
  try {
    if (typeof currency === 'string' && currency.trim()) return prefix + new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency.trim(), maximumFractionDigits: 2 }).format(number);
  } catch {}
  return `${prefix}${plain} · Para birimi netleşiyor`;
}
export const money = formatMoney;
export const moneyText = row => formatMoney(row.amount, row.currency, { estimate: row.priceKind === 'estimate' });
export function safeUrl(value) {
  try { const url = new URL(value); return ['http:', 'https:'].includes(url.protocol) ? url.href : null; } catch { return null; }
}
